import type { FileCollection } from '../../../utils/validationForm';

export interface INewExemption {
  type?: string;
  registration?: string;
  nis?: string;
  mother_name?: string;
  document_number?: string;
  document_issuing_body?: string;
  document_issuing_body_uf?: string;
  attachmentExemption?: FileCollection;
  file_roles?: string[];
  redome_code?: string;
}

export const buildNewExemptionFormData = (data: INewExemption) => {
  const formData = new FormData();

  if (data.attachmentExemption && data.attachmentExemption.length > 0) {
    for (let index = 0; index < data.attachmentExemption.length; index++) {
      const file = data.attachmentExemption[index];
      const role = data.file_roles?.[index];
      if (!role?.trim()) throw new Error(`O anexo ${file.name} está sem identificação do documento.`);
      formData.append('files', file);
      formData.append('file_roles', role);
    }
  }

  if (data.redome_code) formData.append('redome_code', data.redome_code);
  if (data.type) formData.append('type', data.type);
  if (data.registration) formData.append('registration', data.registration);
  if (data.nis) formData.append('nis', data.nis);
  if (data.mother_name) formData.append('mother_name', data.mother_name);
  if (data.document_number) formData.append('document_number', data.document_number);
  if (data.document_issuing_body) formData.append('document_issuing_body', data.document_issuing_body);
  if (data.document_issuing_body_uf) formData.append('document_issuing_body_uf', data.document_issuing_body_uf);

  return formData;
};
